import { FC, PropsWithChildren } from 'react';
import { useMap } from 'react-use';
import { toNumber } from 'lodash';

import { FormTabIndexProviderContext } from './FormTabIndexProvider.context';
import { FormControlIndex } from './FormTabIndexProvider.types';

type FormTabIndexProviderProps = PropsWithChildren<{}>;

export const FormTabIndexProvider: FC<FormTabIndexProviderProps> = ({
  children,
}) => {
  const [indexes, { set: setIndex, remove: removeIndex, get: getItem }] =
    useMap<FormControlIndex>();

  const focusNext = (currentTabIndex: number) => {
    const tabIndexes = Object.keys(indexes)
      .map((v) => toNumber(v))
      .sort();
    const currentIndex = tabIndexes.indexOf(currentTabIndex);
    const nextIndex = currentIndex + 1;
    const nextKey = tabIndexes[nextIndex];
    const control = getItem(nextKey);
    if (control) control.current.setFocus();
  };

  return (
    <FormTabIndexProviderContext.Provider
      value={{ indexes, setIndex, removeIndex, focusNext }}
    >
      {children}
    </FormTabIndexProviderContext.Provider>
  );
};
